import React, { useMemo } from "react";

import { useAppSelector } from "../../../app/store";

import {
  getRelationshipsForStakeholder,
} from "../logic/stakeholderSlice";

import {
  getCreditAccounts,
} from "../../creditAccounts/logic/slice";

import LinkedLoanAccountCard from "./LinkedLoanAccountCard";
import { EntityType } from "../../../api/stakeholder_relationships";

interface LinkedLoanAccountsProps {
  stakeholderId: string;
  onClick: (accountNumber: string) => void;
}

const LinkedLoanAccounts: React.FC<LinkedLoanAccountsProps> = ({
  stakeholderId,
  onClick,
}) => {
  const linkedLoanRelationships = useAppSelector((state) => 
    getRelationshipsForStakeholder(state, stakeholderId, EntityType.LOAN_ACCOUNT)
  );

  const creditAccounts = useAppSelector(
    getCreditAccounts,
  );

  const linkedLoanAccounts = useMemo(() => {
    const linkedAccountNumbers = linkedLoanRelationships.map((relationship) => relationship.entity_id);

    const uniqueAccountNumbers = Array.from(
      new Set(linkedAccountNumbers),
    );

    const accountNumbers = new Set(
      creditAccounts.map(
        (account) => account.account_number,
      ),
    );

    return uniqueAccountNumbers.filter((number) =>
      accountNumbers.has(number),
    );
  }, [
    linkedLoanRelationships,
    creditAccounts
  ]);

  if (!linkedLoanAccounts.length) {
    return null;
  }

  return (
    <div className="px-4">
      <div className="flex w-full flex-col gap-3 rounded-[8px] bg-[#F3F4F6] p-2">
        {/* Header */}
        <div className="flex min-w-0 items-center gap-2">
          <span className="min-w-0 truncate font-[Inter] text-[12px] font-medium leading-none text-[#737373]">
            Linked Loan Accounts
          </span>

          <span
            className="
              inline-flex
              min-w-[20px]
              items-center
              justify-center
              rounded-[8px]
              border
              border-transparent
              bg-[#EBEEFE]
              px-2
              py-[2px]
              font-[Inter]
              text-[12px]
              font-semibold
              leading-4
              text-[#3551F3]
            "
          >
            {linkedLoanAccounts.length}
          </span>
        </div>

        <div className="flex w-full flex-col gap-2">
          {linkedLoanAccounts.map((linkedAccountNumber) => (
            <LinkedLoanAccountCard
              key={linkedAccountNumber}
              accountNumber={linkedAccountNumber}
              onClick={() =>
                onClick(linkedAccountNumber)
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LinkedLoanAccounts;